import { useState } from "react";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { DeleteUserDialog } from "./dialogs/DeleteUserDialog";
import { DisplayDataEdit } from "./DisplayDataEdit";
import "./AccountPreferences.scss";

function DeleteUser() {
  const t = useTranslate("DeleteUser");
  const [showDialog, setShowDialog] = useState(false);

  return (
    <section className="card delete">
      <header>
        <h3>{t("title")}</h3>
        <p>{t("description")}</p>
        <hr />
      </header>
      <DisplayDataEdit
        title={""}
        description={""}
        onEdit={() => setShowDialog(true)}
        editLabel={t("editLabel")}
      />
      {showDialog && <DeleteUserDialog onClose={() => setShowDialog(false)} />}
    </section>
  );
}
export function AccountPreferences() {
  const t = useTranslate("AccountPreferences");

  return (
    <section className="preferences" id="preferences">
      <header>
        <h2>{t("title")}</h2>
        <p>{t("description")}</p>
        <hr />
      </header>
      <DeleteUser />
    </section>
  );
}
